import Tag from '../../../../components/Display/Tag';
import { getConstant } from '../../../../utils/constants';
import { getImage } from '../../../../utils/imageHelper';
import styles from '../../cards.module.scss';
import { ButtonGroup } from 'primereact/buttongroup';
import { Button } from 'primereact/button';

function PopupItem({ popup, handleClickPopup, confirmPopupDeletion }) {
  const onConfirmDeleteClick = (e, member) => {
    e.stopPropagation();
    confirmPopupDeletion(popup);
  };
  return (
    <div className={styles.projectCard} onClick={handleClickPopup}>
      <img
        className={styles.projectImage}
        src={popup?.image ? popup?.image?.file : getImage('img-ph.png')}
        alt={popup?.image ? popup?.image?.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{popup.title}</p>
          <p className={styles.subtitle}>{popup.button_label}</p>
          <p className={styles.subtitle}>{popup.button_link}</p>
          <p className={styles.subtitle}>{popup.content}</p>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('maisonmousse.popUpActive', popup.is_active).label,
              bgColor: getConstant('maisonmousse.popUpActive', popup.is_active).bgColor
            }}
          />
        </div>
      </div>
      {confirmPopupDeletion && (
        <ButtonGroup className={styles.buttonList}>
          <Button
            rounded
            icon="pi pi-trash"
            severity="danger"
            onClick={(e) => onConfirmDeleteClick(e, popup)}
            outlined
            size="small"
            className="!h-9 !w-9"
          />
        </ButtonGroup>
      )}
    </div>
  );
}

export default PopupItem;
